import { useGetSource } from '@/api/generated/sources.ts';
import { PlaceCrumbs } from '@/clients/components/ClientCrumbs.tsx';

import useSourceTitle from '../useSourceTitle.ts';

const SourceCrumb = ({ sourceId }: { sourceId: string }) => {
    const source = useGetSource(sourceId);
    const getTitle = useSourceTitle();

    if (source.error) return <>{sourceId}</>;
    if (!source.data) return null;
    return <>{getTitle(source.data)}</>;
};

export const SourceParentCrumbs = ({ sourceId }: { sourceId: string }) => {
    const source = useGetSource(sourceId);

    if (!source.data) return null;
    return <PlaceCrumbs item={source.data} navKey="sources" />;
};

export default SourceCrumb;
